import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'

import componentCanCrash from '../../utils/components/componentCanCrash'
import userHasCustomTourOperatorsOverwrite from '../../utils/tourOperators/userHasCustomTourOperatorsOverwrite'

import { v1requestUser } from '../../actions/users'

import CustomTourOperator from '../../components/CustomTourOperator'

export const mapStateToProps = state => {
  return {
    showCustomTourOperator: userHasCustomTourOperatorsOverwrite(),
    userTourOperatorCode: state.v1user.customTOPCode || state.v1user.topCode,
    isFetching: state.v1user.isFetching,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ requestUser: v1requestUser }, dispatch)

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  componentCanCrash
)(CustomTourOperator)
